import styled from '@emotion/styled';
import { Avatar, Button, Tooltip, Typography, Zoom } from '@mui/material';
import Image from 'next/image';
const TagCardDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
`;
const BoxImage = styled(Avatar)`
  width: 200px;
  height: 200px;
  //border: 2px solid #bf9bb9;
  background: transparent;
  object-fit: contain;
`;

const BookingBoxImage = styled(Avatar)`
  width: 100px;
  height: 100px;
  border: 2px solid #bf9bb9;
  background: transparent;
  object-fit: contain;
`;
const StyledImage = styled(Image)`
  object-fit: contain;
`;
const ImageTitle = styled(Typography)`
  font-family: var(--font-work-sans);
  color: #ffffff;
  text-align: center;
`;

type IconProps = {
  url?: string;
  key?: string;
};

type TagButtonProps = {
  id?: string;
  title?: string;
  icon?: IconProps;
  description?: string;
  selected?: boolean;
};

export function TagDisplayCard({ tag }: { tag: TagButtonProps }) {
  return (
    <TagCardDiv>
      <Tooltip
        title={tag.description}
        TransitionComponent={Zoom}
        placement="bottom"
        PopperProps={{ style: { marginTop: 15 } }}
      >
        <Button variant="text">
          <BoxImage>
            <StyledImage src={tag.icon!.url!} alt={tag.icon!.key!} width={165} height={165} />
          </BoxImage>
        </Button>
      </Tooltip>
      <ImageTitle>{tag.title}</ImageTitle>
    </TagCardDiv>
  );
}

export function BookingTagDisplayCard({ tag }: { tag: TagButtonProps }) {
  return (
    <TagCardDiv>
      <Tooltip
        title={tag.description}
        TransitionComponent={Zoom}
        placement="bottom"
        PopperProps={{ style: { marginTop: 15 } }}
      >
        <Button variant="text">
          <BookingBoxImage>
            <StyledImage src={tag.icon!.url!} alt={tag.icon!.key!} width={165} height={165} />
          </BookingBoxImage>
        </Button>
      </Tooltip>
      <ImageTitle>{tag.title}</ImageTitle>
    </TagCardDiv>
  );
}
